import { urlEscaped } from '@app/utils/urlEscaped'

import { createApiAction } from '@app/packages/api/utils'
import type { ApiAvatar } from '@app/packages/api/v2/types/entities'

export const postAvatars = (avatar: File) =>
  createApiAction('postAvatars', dispatch => {
    const body = new FormData()
    body.append('file', avatar)
    return dispatch<{ data: ApiAvatar }>({ method: 'POST', endpoint: '/api/v2/avatars', body })
  })

export const deleteAvatars = (avatarId: string) =>
  createApiAction('deleteAvatars', dispatch => dispatch<unknown>({ method: 'DELETE', endpoint: urlEscaped`/api/v2/avatars/${avatarId}` }))
